import { observable, action, runInAction, toJS } from "mobx";

import * as LoginAPI from "../../../api/pc/login";
import {
  inApp,
  inAppRouteWhiteList,
  inCustomLogin,
  inLoginPage,
  isObjectEmpty,
  isPassIntunifyAuth,
  isPrivateEnv,
  isPrivateLogin
} from "../../../utils";
import { getDefaultSkinData } from "../../../mock";
import { parse } from "qs";
import { off } from "process";
import { weappSDK, getLabel } from "@weapp/utils";
import { MDialog } from "@weapp/ui";
import { LOCATION_ORIGN, publicUrl } from "../../../constants";
const { toast } = MDialog;

export class SkinStore {

  @observable loginSkinData: any = {};
  @observable ebLoginSkinData: any = null;//自定义页面数据
  @observable ebLoginConfig: any = null;//自定义页面数据
  @observable isCustomPage: boolean = false;
  @observable customPagePath: string = '';//自定义路由
  @observable customTenantKey: string = '';//自定义登录页用户的租户key
  @observable tgtChecked: boolean = false;
  @observable mockSkinData: any = {};
  @observable isEmptyPage = true;//空白页过渡
  @observable activeLoginType = 'phone';
  @observable safeAccountLogin = []; //安全设置系统登录方式
  @observable isLoginPageGrey: boolean = false; // 页面置灰开关
  @observable ebEcodeId: any = '';
  @observable ebPageId: any = '';

  @action
  init = () => {
    const mark = isPrivateEnv() ? 'private_h5' : 'public_h5';
    // @ts-ignore
    this.mockSkinData = getDefaultSkinData(mark);
    if (inCustomLogin()) {
      //自定义登录地址
      this.getCustomPageByPath();
    } else {
      let customPageData: any = localStorage.getItem('e_customPageData_H5');

      if (customPageData && !inLoginPage()) {
        const customPageDataTemp = JSON.parse(customPageData);
        const skinData = (customPageData)?.loginSkin ? JSON.parse(customPageData.loginSkin) : {};
        if (!skinData?.pageInfo) skinData.pageInfo = {};

        let urlParams = parse(window.location.search?.replace('?', '')) || {}; //手机号区位码非登录页控制，eb设计器等手机号控制字段补充(loginSkin-pageInfo-mobileArcode)
        if (urlParams.mobileAreaCode === 'true') {
          skinData.pageInfo = { ...customPageDataTemp.pageInfo, mobileAreaCode: 'true', accountTypeFirst: urlParams?.accountTypeFirst }
          customPageDataTemp.loginSkin = JSON.stringify(skinData)
        }
        if (urlParams.from === 'loginSetting') {//来源-后台管理中心eb登录页配置
          if (urlParams.mobileAreaCode !== 'true') {//没有开启优先手机号时删除默认数据中存在的值
            delete skinData.pageInfo.mobileAreaCode
          }
          customPageDataTemp.loginSkin = JSON.stringify(skinData)
        }
        this.updateCustomData({
          data: customPageDataTemp
        }, true);

      } else {
        //自定义域名或云端地址默认配置数据
        const origin = LOCATION_ORIGN;
        LoginAPI.getCustomDomainSkin(origin, 'h5').then((result: any) => {
          runInAction(() => {
            //是自定义登录页
            if (result.data?.loginSkin) {

              this.updateCustomData(result);
            } else {
              const loginSkinData = { ...this.mockSkinData } as any;

              loginSkinData.pageInfo = { ...(loginSkinData?.pageInfo || {}), ...(result.data?.page?.pageInfo || {}) };

              if (result.data?.page.mobileAreaCode === 'true') {//高级登录页补充优先手机号字段
                if (!loginSkinData?.pageInfo) loginSkinData.pageInfo = {};
                loginSkinData.pageInfo = { ...loginSkinData.pageInfo, mobileAreaCode: 'true', accountTypeFirst: result.data?.page?.accountTypeFirst }
              }

              let data: any = {
                loginSkin: JSON.stringify(loginSkinData)
              }
              // eb登录高级版
              if (result.data?.page?.comps) {
                data.comps = result.data.page.comps
              }
              if (result.data?.page?.config) {
                data.config = result.data.page.config;
              }
              if (result.data?.tenantKey) {
                data.tenantKey = result.data?.tenantKey;
              }
              if (result.data?.page?.ecodeId) {
                data.ecodeId = result.data.page.ecodeId;
              }
              if (result.data?.page?.id) {
                data.ebPageId = result.data.page.id;
              }
              //账号安全相关配置
              if (result.data?.safetyConfig) {
                data.safetyConfig = result.data?.safetyConfig
              }
              this.updateCustomData({
                data: data
              });
            }
          });
        }).catch((error) => {
          console.log(error);
          //取本地兜底数据
          runInAction(() => {
            this.updateCustomData({
              data: {
                loginSkin: this.mockSkinData
              }
            });
          })
        });
      }

    }
  }

  @action
  updateActiveLoginType = (value: string) => {
    this.activeLoginType = value;
  }
  // 更新自定义数据
  @action
  updateCustomData = (result: any, noSave = false) => {
    let customPageData = {
      ...result.data,
      // origin: origin
    }
    if (!noSave) {

      localStorage.setItem('e_customPageData_H5', JSON.stringify(customPageData));
    }
    window.e_customPageData = customPageData;
    runInAction(() => {
      this.loginSkinData = typeof customPageData.loginSkin === 'string' ? JSON.parse(customPageData.loginSkin) : customPageData.loginSkin;
      this.ebLoginSkinData = typeof customPageData.comps === 'string' ? JSON.parse(customPageData.comps) : customPageData.comps;
      this.ebLoginConfig = typeof customPageData.config === 'string' ? JSON.parse(customPageData.config) : customPageData.config;
      this.ebEcodeId = customPageData?.ecodeId || '';
      this.ebPageId = customPageData?.ebPageId || '';
      if (!this.loginSkinData.modeId || this.loginSkinData.modeId === 10000) {
        this.loginSkinData = {
          ...this.mockSkinData,
          ...this.loginSkinData,
        }
      }

      if (window.weappUtils?.initPageGrey) { // 为了避免依赖，优先使用公共组的置灰方法，待后期再移除自有设置
        window.weappUtils.initPageGrey(!!result.data.loginPageGreyStatus)
      } else {
        this.isLoginPageGrey = !!result.data.loginPageGreyStatus // 置灰设置
      }

      if (result.data?.tenantKey) {
        this.customTenantKey = result.data.tenantKey;
      }
      const tenantKey = result.data?.tenantKey || window.TEAMS?.currentTenant?.tenantKey;
      if (tenantKey) {
        this.getSafeAccount({ tenantKey })
      }

      if (this.loginSkinData?.pageInfo && this.loginSkinData?.pageInfo?.mobileAreaCode === 'true') {
        if (!this.loginSkinData?.pageInfo?.accountTypeFirst) {
          this.updateActiveLoginType('other');
        }
      }

      if (inApp()) {//app登录方式处理
        weappSDK.exec("getItem", {
          key: "activeLoginType", // 存储的数据标识
          isPublic: "0",//iOS用到，1登录后存储，0登录前存储
        }).then((res: any) => {
          if (res?.value) {//记住账号时控制tab切换，默认为其他方式展示
            const e_login_loginType = res.value;
            const activeTab = e_login_loginType === 'phone' ? 'phone' : 'other';
            this.updateActiveLoginType(activeTab);
          }
        });
      } else {//h5登录方式处理
        const e_login_loginType = localStorage.getItem('activeLoginType');
        if (e_login_loginType) {//记住账号时控制tab切换，默认为其他方式展示
          const activeTab = e_login_loginType === 'phone' ? 'phone' : 'other';
          this.updateActiveLoginType(activeTab);
        }
      }
      this.isEmptyPage = false;
    })
  }

  @action
  getCustomPageByPath = () => {
    //自定义登录地址
    if (inCustomLogin()) {
      //集成登录
      this.checkIntunifyauth();
    }
    else {
      //   if (inPCRouteWhiteList()) {
      runInAction(() => {
        this.isEmptyPage = false;
      });
      //   }
    }

  }

  @action
  checkIntunifyauth = () => {
    // let path = window.location.pathname;
    let path = window.location.pathname.split('customlogin')[1];
    if (path && path !== '/') {
      if (isPassIntunifyAuth()){
        this.getLoginSkinData();
      } else {
        LoginAPI.checkIntunifyauth(path, 'h5').then((result) => {
          if (result?.data?.errorMsg) {
            const msg = result.data.errorMsg
            toast({
              content: getLabel(msg.i18nId, msg.msg),
              delay: 2000
            });
          } else {
            if (result.data.relativeUrl) {
              window.location.href = `${window.passport_runInfo?.weappUrl || ''}${result.data.relativeUrl}${result.data.relativeUrl.indexOf('?') !== -1 ? '&' : '?'}redirect_uri=${encodeURIComponent(window.passport_runInfo?.weappUrl || '')}`
            } else if (result?.data?.redirectUrl) {
              window.location.href = result.data.redirectUrl;
            } else {
              //检测并获取是否是自定义页面
              this.getLoginSkinData();
            }
          }
        }).catch((error) => {
          runInAction(() => {
            this.isEmptyPage = false;
          });
          // 此处需要判断是否安装环境
          window.location.href = `${LOCATION_ORIGN}${publicUrl}/login`;
        });
      }
    }
  }
  @action //获取安全设置登录方式
  getSafeAccount = (data: any) => {
    LoginAPI.getSafeAccount(data).then((result) => {
      runInAction(() => {
        if (result.code === 200) {
          this.safeAccountLogin = result.data || [];
        }
      })
    })
  }
  @action
  getLoginSkinData = () => {
    // let path = window.location.pathname;
    let path = window.location.pathname.split('customlogin/')[1];
    if (path && path !== '/') {
      LoginAPI.getSkinConfig(path, 'h5').then((result: any) => {
        runInAction(() => {
          //是自定义登录页
          if (result.data?.loginSkin) {
            this.updateCustomData(result);
            this.customPagePath = '/customlogin/' + path;
            localStorage.setItem('e_customloginUrl', `/customlogin/${path}`);//自定义登录页存储地址,注册等返回跳转使用
          } else if (result.data?.page?.comps) {//高级版

            const loginSkinData = { ...this.mockSkinData } as any;

            loginSkinData.pageInfo = { ...(loginSkinData?.pageInfo || {}), ...(result.data?.page?.pageInfo || {}) };

            if (result.data?.page.mobileAreaCode === 'true') {//高级登录页补充优先手机号字段
              if (!loginSkinData?.pageInfo) loginSkinData.pageInfo = {};
              loginSkinData.pageInfo = { ...loginSkinData.pageInfo, mobileAreaCode: 'true', accountTypeFirst: result.data?.page?.accountTypeFirst }
            }

            let data: any = {
              loginSkin: JSON.stringify(loginSkinData),
              loginPageGreyStatus: result?.data?.loginPageGreyStatus,
              comps: result.data?.page?.comps,
              config: result.data?.page?.config,
              tenantKey: result.data?.tenantKey,
              safetyConfig: result.data?.safetyConfig, //TODO 待确定是否更新配置
              ecodeId: result.data?.page?.ecodeId,
              ebPageId: result.data?.page?.id
            }
            this.updateCustomData({ data: data });
            localStorage.setItem('e_customPageUrl', '/customlogin/' + path);
            localStorage.setItem('e_customloginUrl', '/customlogin/' + path);//自定义登录页存储地址,注册等返回跳转使用
          } else {
            localStorage.removeItem('e_customPageData_H5');
            window.location.href = `${LOCATION_ORIGN}${publicUrl}/`;
          }
        });
      }).catch((error) => {
        console.log(error);
        window.location.href = `${LOCATION_ORIGN}${publicUrl}/`;
      });
    }
  }


}

const instance = new SkinStore();

export default instance;
export type SkinStoreType = Pick<SkinStore, keyof SkinStore>;
